import * as Constants from "../common/Constants";

const initialState = {

    branch: null,
    branches: [],
    isLoading: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function (state = initialState, action) {

    switch (action.type) {
        case Constants.REQUEST_ADD_BRANCH:
            return {
                ...state,
                isLoading: false,
                isPosted: false,
                isPosting: true,
                error: null
            };

        case Constants.SUCCESS_ADD_BRANCH:
            return {
                ...state,
                isLoading: false,
                isPosted: true,
                isPosting: false,
                error: null
            };

        case Constants.REQUEST_GET_BRANCHES:
            return {
                ...state,
                isLoading: true,
                isPosted: false,
                isPosting: false,
                error: null
            };

        case Constants.SUCCESS_GET_BRANCHES:
            return {
                ...state,
                isLoading: false,
                isPosted: false,
                isPosting: false,
                error: null,
                branches: action.branches
            };

        case Constants.FAILED_ADD_BRANCH:
        case Constants.FAILED_GET_BRANCHES:
        case Constants.FAILED_GET_BRANCH:
        case Constants.FAILED_UPDATE_BRANCH:
            return {
                ...state,
                isLoading: false,
                isPosted: false,
                isPosting: false,
                error: action.error
            };
        case Constants.RESET_ORG_UNIT:
            return {
                ...state,
                isLoading: false,
                isPosting: false,
                isPosted: false,
                error: null
            };

        case Constants.REQUEST_GET_BRANCH:
            return {
                ...state,
                isLoading: true,
                isPosted: false,
                isPosting: false,
                error: null
            };
        case Constants.SUCCESS_GET_BRANCH:
            return {
                ...state,
                isLoading: false,
                isPosted: false,
                isPosting: false,
                error: null,
                branch: action.payload
            };

        case Constants.REQUEST_UPDATE_BRANCH:
            return {
                ...state,
                isLoading: true,
                isPosted: false,
                isPosting: false,
                error: null
            };
        case Constants.SUCCESS_UPDATE_BRANCH:
            return {
                ...state,
                isLoading: false,
                isPosted: false,
                isPosting: false,
                error: null,
                branch: action.payload
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/OrgUnitReducer.js